import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/system'
import { Skeleton } from '@mui/material'

const SkeletonLoading = ({ variant, length = 3, sx }) => {
  if (variant === 'text') {
    return (
      <Box width={'100%'}>
        {[...Array(length)].map((_, idx) => (
          <Box key={idx} width={'100%'} mb={2}>
            <Skeleton
              variant="text"
              sx={{
                width: '80%',
              }}
            />
            <Skeleton
              variant="text"
              sx={{
                width: '60%',
              }}
            />
            <Skeleton
              variant="text"
              sx={{
                width: '100%',
              }}
            />
          </Box>
        ))}
      </Box>
    )
  }
  return (
    <React.Fragment>
      {[...Array(length)].map((_, idx) => (
        <Box key={idx} width={'100%'} mb={2}>
          <Skeleton
            variant="text"
            sx={{
              width: '100%',
              height: 100,
              transform: 'scale(1)',
              ...sx,
            }}
          />
        </Box>
      ))}
    </React.Fragment>
  )
}
SkeletonLoading.defaultProps = {
  length: 3,
  variant: 'default',
}

SkeletonLoading.propTypes = {
  length: PropTypes.number,
  variant: PropTypes.oneOf(['default', 'text']),
}

export default SkeletonLoading
